<div class="floors-actions-wrapper">
  <!-- UPLOADING SPINNER -->
  <div *ngIf="uploadingFloorPlan" class="spinner-container">
    <mat-spinner diameter="20"></mat-spinner>
    <p>{{ 'commonLabels.uploading' | xTranslate }}</p>
  </div>
  <!-- DELETE FLOOR -->
  <mat-icon
    svgIcon="delete"
    [class.disabled]="disableDeleteFloor"
    [matTooltip]="'moreInfo.deleteFloor' | xTranslate"
    matTooltipPosition="above"
    (click)="!disableDeleteFloor && deleteFLoor()"
  ></mat-icon>
  <!-- REMOVE / ADD FLOOR PLAN -->
  <div>
    <mat-icon
      *ngIf="selectedFloorGroup.length"
      [svgIcon]="hasFloorPlan ? 'remove-file' : 'add-file'"
      [matTooltip]="'moreInfo.removePlan' | xTranslate"
      matTooltipPosition="above"
      [class.disabled]="disableFloorPlan"
      (click)="hasFloorPlan ? removeFloorPlan() : null"
    ></mat-icon>
    <ng-container *ngTemplateOutlet="addFloorPlan"></ng-container>
  </div>
  <!-- DOTS MENU -->
  <mat-icon svgIcon="more-icon" [matMenuTriggerFor]="menu" [class.disabled]="disableDotsMenu"></mat-icon>
</div>

<!-- ADD FLOOR PLAN INPUT -->
<ng-template #addFloorPlan>
  <label
    *ngIf="!hasFloorPlan"
    #addFloorPlanLabel
    for="add-floor-plan"
    tabindex="-1"
    (focus)="manageFileDialogState(addFloorPlanLabel)"
    [matTooltip]="'moreInfo.addFloorPlan' | xTranslate"
  >
    <input
      id="add-floor-plan"
      type="file"
      [style.display]="'none'"
      (change)="onFileChange.emit({ event: $event, floors: selectedFloorGroup })"
    />
  </label>
</ng-template>

<!-- DOTS MENU OPTS -->
<mat-menu #menu="matMenu">
  <button
    *ngIf="showCommonFloorSize"
    mat-menu-item
    (click)="onSetFloorSpace()"
    [disabled]="!generalCommonFloorSizeFG.value.val"
  >
    {{ 'moreInfo.setAverageFloorSize' | xTranslate }}
  </button>
  <button
    id="e2e-toggle-visibility-btn"
    mat-menu-item
    [disabled]="disableShowHideFloor"
    (click)="toggleFloorVisibility()"
    [matTooltip]="$toggleVisibilityDisabledTooltip() | xTranslate"
    matTooltipPosition="left"
  >
    {{ (hideShowLabel ? 'moreInfo.showFloor' : 'moreInfo.hideFloor') | xTranslate }}
  </button>
  <button
    id="e2e-move-floor-btn"
    mat-menu-item
    [disabled]="disableMoveFloor"
    (click)="move()"
    [matTooltip]="$moveFloorDisabledTooltip() | xTranslate: aboveAndUnderFloor"
    matTooltipPosition="left"
  >
    {{ 'moreInfo.moveFloor' | xTranslate }}
  </button>
</mat-menu>
